import React from 'react'

import Loader from 'Components/UI/_v2/Loader'

function LoadingIndicator() {
  return <Loader />
}

export default LoadingIndicator
